import { useAuth0 } from '@auth0/auth0-react';
import { getInitialsFromName, Image } from '@/lib/Image';
import { FC } from 'react';
import { twMerge } from 'tailwind-merge';
import { LogoutButton } from './LogoutButton';

export const UserCard: FC = () => {
  const { user } = useAuth0();

  return (
    <div
      className={twMerge(
        'flex h-fit w-full flex-row border-t border-secondary-border ps-2 pt-5 pe-0 gap-2 items-center',
        'motion-safe:transition-[padding,border] motion-safe:duration-500 motion-reduce:transition-none',
        'group-data-[expanded=false]/sidebar:border-0 group-data-[expanded=false]/sidebar:p-0'
      )}
    >
      <Image
        src={user?.picture}
        alt={user?.name ?? 'User avatar'}
        className='size-10 rounded-full object-cover'
        fallback={
          <span
            className='flex size-10 shrink-0 items-center justify-center rounded-full bg-secondary-100 text-sm font-semibold text-secondary-700'
            role='img'
            aria-label={user?.name ?? 'User avatar'}
          >
            {getInitialsFromName(user?.name)}
          </span>
        }
      />
      <div
        className={twMerge(
          'grid *:truncate *:text-sm',
          'motion-safe:transition-opacity motion-safe:delay-200 motion-safe:duration-500 motion-reduce:transition-none',
          'group-data-[expanded=false]/sidebar:opacity-0 group-data-[expanded=false]/sidebar:motion-safe:delay-0 group-data-[pinned=true]/sidebar:motion-safe:delay-0'
        )}
      >
        <p className='font-semibold text-primary-900'>{user?.name}</p>
        <p className='text-tertiary-600'>{user?.email}</p>
      </div>
      <LogoutButton />
    </div>
  );
};
